export const URLS = {
    integrations: () => '/integrations',

    profile: () => '/user/account',

    staffStixifyProfiles: () => '/staff/extraction-profiles',

    teamAddReport: (team_id: string) => '/reports/add',
    teamJobs: (team_id: string) => `/${team_id}/jobs`,
    teamJobDetail: (team_id: string, report_id: string, job_id: string) => `/${team_id}/${report_id}/jobs/${job_id}`,
    teamManagement: (team_id) => `/teams/${team_id}`,
    teamReports: (team_id, filter={}) => `/reports?profile_id=${filter.profile_id || ''}&team_id=${filter.team_id || ''}`,
    teamDossiers: (team_id, filter={}) => `/dossiers?report_id=${filter.report_id || ''}`,
    teamAddDossier: (team_id: string) => '/dossiers/add',
    teamEditDossier: (team_id: string, id: string) => `/dossiers/${id}/edit`,
    teamDossierDetail: (team_id: string, id: string) => `/dossiers/${id}`,
    teamIntelligenceSearch: (team_id: string, type: string, value: string) => `/type=${type}&value=${value}`,

    intelligence: () => '/intelligence',
    teamStixifyProfileDetail: (team_id, id) => `/teams/${team_id}/profiles/${id}`,
    teamStixifyProfileAdd: (team_id) => `/teams/${team_id}/profiles/add`,
    teamReportDetail: (team_id, report_id) => `/reports/${report_id}`,
    teamExtractionReports: (team_id: string, objectId: string, type: string, scoValue: string) => `/intelligence/${objectId}?value=${scoValue}&type=${type}`,
    vulnerabilityDetailPage: (cve_id: string) => `/vulnerabilities/${cve_id}`,
    vulnerabilityListPageForCpe: (cpe_id: string) => `/vulnerabilities/?cpes_vulnerable=${cpe_id}`,

    staffDossiers: () => '/staff/dossiers',
    staffDossierDetail: (id: string) => `/staff/dossiers/${id}`,
    staffReports: (filter={}) => `/staff/reports?profile_id=${filter.profile_id || ''}`,
    staffReportDetail: (report_id: string) => `/staff/reports/${report_id}`,
    staffJobs: () => `/staff/jobs`,
    staffJobDetail: (report_id: string, job_id: string) => `/staff/reports/${report_id}/jobs/${job_id}`,
    staffProfiles: () => `/staff/profiles`,
    staffProfileDetail: (profile_id: string) => `/staff/profiles/${profile_id}`,
    staffProfileEdit: (profile_id: string) => `/staff/profiles/${profile_id}/edit`,
    notFound: () => `/404`,
  }
